import { validaEmails, validaNames } from "../../helpers/forms/Validation";
import { RESET_CATEGORY, UPDATE_CATEGORY } from "./actionTypes";
import * as Yup from "yup";

const categoryBase = {
    id: null,
    name: '',
    code: '',
    department_id: ''
}
const initialState = {
    category: { ...categoryBase },
    validations: {
        name: validaNames(),
        code: Yup.string().required('El identificador es obligatorio'),
        department_id: Yup.string().required('El identificador es obligatorio'),
    }
};

const category = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_CATEGORY:
            // Actualizar el estado
            return {
                ...state,
                category: action.payload
            };
        case RESET_CATEGORY:
            return {
                ...state,
                category: { ...categoryBase }
            };
        default:
            return state;
    }
};

export default category;
